<header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">{{ header || "Coming soon" }}</div>
    </div>
  </div>
</header>
<app-status-page kind="coming-soon" [title]="title"
                 message="It's being built and will appear here in an upcoming release of Smart TOS.">
</app-status-page>
